import { Dictionary } from "../consts/const-dictionary";
import { gsap } from "gsap";
import { ScrollToPlugin } from "../assets/js/gsap/all";
import dotdotdot from "dotdotdot-js";

gsap.registerPlugin(ScrollToPlugin);

export const isTouchDevice = () => {
  return window.matchMedia("(pointer: coarse)").matches;
};

export const isMobile = () => {
  return window.matchMedia("(max-width: 767px)").matches;
};

export const isTablet = () => {
  return window.matchMedia("(max-width: 1023px)").matches;
};

export const isPhonePortrait = () => {
  return window.matchMedia("(min-width: 320px) and (max-width: 550px)").matches;
};

export const isDesktop = () => {
  return window.matchMedia("(min-width: 1024px)").matches;
};

export const isXSmall = () => {
  return window.matchMedia("(max-width: 767px)").matches;
};
export const isSmall = () => {
  return window.matchMedia("(min-width: 768px)").matches;
};
export const isMedium = () => {
  return window.matchMedia("(min-width: 1024px)").matches;
};
export const isLarge = () => {
  return window.matchMedia("(min-width: 1200px)").matches;
};
export const isXLarge = () => {
  return window.matchMedia("(min-width: 1440px)").matches;
};
export const isXXLarge = () => {
  return window.matchMedia("(min-width: 1920px)").matches;
};

export const setLockedViewport = (bool, enableScrollUOffset = true) => {
  const b = document.body.style;

  if (bool) {
    enableScrollUOffset ? document.body.setAttribute("data-scrollY-offset", window.pageYOffset) : null;
    b.position = "fixed";
    b.height = "100vh";
    b.overflow = "auto";
    b.width = "100%";
  } else {
    b.position = "";
    b.height = "";
    b.overflow = "";
    b.width = "";

    if (enableScrollUOffset) {
      const scrollYOffset = document.body.getAttribute("data-scrollY-offset");
      if (scrollYOffset) window.scrollTo(0, scrollYOffset);
    }

  }
};

export const setLockedScrollPosition = (findPosition = false) => {

  if (findPosition) {
    document.body.setAttribute("data-scrollY-offset", window.pageYOffset);
    document.body.style.position = "fixed";
    document.body.style.width = "100%";

    const scrollYOffset = document.body.getAttribute("data-scrollY-offset");
    if (scrollYOffset) document.body.style.top = -scrollYOffset + "px";
  } else {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";

    const scrollYOffset = document.body.getAttribute("data-scrollY-offset");
    if (scrollYOffset) window.scrollTo(0, scrollYOffset);
  }
};

export const setTouchAction = bool => {
  const b = document.querySelector("body");

  if (bool) {
    b.addEventListener("touchmove", (e) => {
      e.preventDefault();
    }, false);

  } else {

    b.removeEventListener("touchmove");
  }
};

export const scrollToId = (id, duration = .5, easing = "power2.inOut") => {
  if (typeof document === "undefined" || typeof window === "undefined") return null;
  gsap.to(window, { duration: duration, scrollTo: `#${id}`, ease: easing });
};

export const getViewPortWidth = () => {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
};

export const getViewPortHeight = () => {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
};

export const scrollToTarget = (targetSelector, offsetY = 80, duration = .5, easing = "power2.inOut") => {
  if (typeof document === "undefined" || typeof window === "undefined") return null;
  gsap.to(window, {
    duration: duration,
    scrollTo: { y: targetSelector, offsetY: offsetY },
    ease: easing,
  });
};

export const formatMoney = (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    const negativeSign = amount < 0 ? "-" : "";
    const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    const j = (i.length > 3) ? i.length % 3 : 0;
    return negativeSign + (j ? i.substr(0, j) + thousands : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e);
  }
};

export const getRandomId = () => {
  return `id_${Math.random().toString().slice(2)}`;
};

export const isIE = () => {
  // IE 10 and IE 11
  return /Trident\/|MSIE/.test(window.navigator.userAgent);
};

export const debounce = (func) => {
  let timer;
  return function(event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func,100,event);
  };
};

export const fromAnim = (position) => {

  if (position === "bottom") {
    return {
      autoAlpha: 0,
      y: 15,
    };
  } else {
    return {
      autoAlpha: 0,
      x: -15,
    };
  }
};

export const toAnim = (speed) => {
  return {
    stagger: speed ? speed : 0.1,
    autoAlpha: 1,
    y: 0,
    x: 0,
    ease: "power1.easeInOut",
    delay:0,
    yoyo: true,
  };
};

export const toAnimOpacity = () => {
  return {
    stagger: 0.2,
    autoAlpha: 1,
    ease: "power1.easeInOut",
    delay:0,
    yoyo: true,
  };
};

export const getElementPosition = (el, customScrollContainer) => {

  const { top, left } = el.getBoundingClientRect(), scrollLeft = customScrollContainer ? customScrollContainer.scrollLeft : window.pageXOffset || document.documentElement.scrollLeft, scrollTop = customScrollContainer ? customScrollContainer.scrollTop : window.pageYOffset || document.documentElement.scrollTop;

  return { top: top + scrollTop, left: left + scrollLeft };
};

export const getMousePosition = (evt) => {
  let pageX = evt.pageX;
  let pageY = evt.pageY;
  if (pageX === undefined) {
    pageX = evt.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    pageY = evt.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }

  const rect = evt.target.getBoundingClientRect();
  const offsetX = evt.clientX - rect.left;
  const offsetY = evt.clientY - rect.top;

  return {
    client: { x: evt.clientX, y: evt.clientY }, // relative to the viewport
    screen: { x: evt.screenX, y: evt.screenY }, // relative to the physical screen
    offset: { x: offsetX, y: offsetY }, // relative to the event target
    page:   { x: pageX, y: pageY }, // relative to the html document
  };
};

export const getFormattetDate = (date) => {
  const StartDateFormattet = new Date(date);
  const Month = Dictionary.MonthNames[StartDateFormattet.getMonth()];
  const StartDayDate = StartDateFormattet.getDate();
  const StartDay = StartDayDate < 10 ? "0" + StartDayDate : StartDayDate;
  const year = StartDateFormattet.getFullYear();

  return StartDay + ". " + Month + " " + year;
};

export const shyString = (text) => {
  const str = String(text);
  return str.replace(/~/g, "&shy;");
};

export const scrollToElement = (el) => {
  const divOffset = getElementPosition(el);
  const menuHeight = document.querySelector(".side-wrapper").clientHeight;

  window.scrollTo({
    top: divOffset.top - menuHeight,
    behavior: "smooth",
  });

};

export const thousandSeparator = (numberOrString, culture) => {
  const converted = parseFloat(numberOrString).toLocaleString(culture);
  if (culture === "da-DK") return converted.split(",").join(".");
  return converted;
};

export const getIcon = (id, className) => `<svg class="svg-${id}${className ? className : ""}"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-${id}"></use></svg>`;

export const truncate = (nodes) => {
  if (nodes) {
    nodes.forEach((node) => {
      const options = {};
      new dotdotdot(node, options);
    });
  }
};

export const toggleSpinner = (el, show) => {
  //Add the spinner
  let spinner = el.querySelector(".ff-spinner");

  if (show && !spinner) {
    spinner = document.createElement("div");
    spinner.classList.add("ff-spinner");
    el.appendChild(spinner);
  } else if (spinner) {
    el.removeChild(spinner);
  }
};

export const isPrint = () => {
  return window.matchMedia("print").matches;
};

export const setToMonday = (date) => {
  const day = date.getDay() || 7;
  if ( day !== 1 )
    date.setHours(-24 * (day - 1));
  return date;
};

export const replaceAllHelper = (string, search, replace) => {
  return string && search ? string.split(search).join(replace) : "";
};

export const animateNumber = (el, startNumber, finishNumber, counterSpeed) => {
  const speed = 200; // The lower the slower

  const updateCount = () => {
    const target = +finishNumber;
    const count = +el.innerText;

    // Lower inc to slow and higher to slow
    const inc = target / speed;

    // Check if target is reached
    if (count < target) {
      // Add inc to count and output in counter
      el.innerText = Math.ceil(count + inc);
      // Call function every ms
      setTimeout(updateCount, counterSpeed ? counterSpeed : 10);
    } else {
      el.innerText = target;
    }
  };

  updateCount();

};

export const getPixelWidth = (width) => {
  return window.devicePixelRatio > 1 ? parseInt(window.devicePixelRatio * width) : width;
};

export const tryParseJSONObject = (jsonString) => {
  try {
    const o = JSON.parse(jsonString);

    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (o && typeof o === "object") {
      return o;
    }
    // eslint-disable-next-line no-empty
  } catch (e) { }

  return false;
};
